import { capitalizeFirstLetter } from '@resistapp/common/friendly';
import { Chip, CtCsvRow, CtsColumns, ctsHeaders, FullSamplesByUID } from '@resistapp/common/types';
import { chain, Dictionary, get, groupBy, sortBy } from 'lodash';

export function compileCtsFiles(chips: Array<Pick<Chip, 'id' | 'name'>>, samplesByUID: FullSamplesByUID) {
  const allCts: CtsColumns[] = chain(samplesByUID)
    .values()
    .flatten()
    .flatMap(sample => sample.abundances.flatMap(a => a.cts || []))
    .value();

  const ctsByChip = groupBy(allCts, ct => ct.chipId);

  return chips.reduce<Dictionary<string>>((files, chip) => {
    const chipCts = get(ctsByChip, chip.id, undefined);
    if (!chipCts || chipCts.length === 0) {
      return files;
    }
    const linebreak = '\r\n';
    const headerRow = ctsHeaders.map(capitalizeFirstLetter).join('\t') + linebreak;
    const dataRows = sortBy(chipCts, ct => ct.id)
      .map((ct: CtCsvRow) => ctsHeaders.map((header: keyof CtCsvRow) => ct[header]).join('\t'))
      .join(linebreak);
    files[`${chip.name}.txt`] = headerRow + dataRows;
    return files;
  }, {});
}
